// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph_Paragraph__q_Qc4","Paragraph___lg":"Paragraph_Paragraph___lg__WHYgR","Paragraph___strong":"Paragraph_Paragraph___strong__KejhL"};